import { usePathname } from "next/navigation";
import { useRouter } from "next/navigation";

export function useActivePath() {
  const pathname = usePathname();

  const checkActivePath = (path: string, endsWithPath?: boolean) => {
    if (path === "/" && pathname !== path) {
      return false;
    }
    if (endsWithPath) {
      return pathname.endsWith(path);
    }
    return pathname.startsWith(path);
  };

  return checkActivePath;
}

export const useNavigationController = () => {
  const router = useRouter();

  const navigate = (href: string, state: string) => {
    state ? router.push(`${href}?state=${state}`) : router.push(href);
  };

  const navOnClick = (page: string, section: string) => {
    navigate(page, section);
  };

  return {
    navigate,
    navOnClick,
  };
};
